<template>
  <div id="container">
    <div class="product-status">
      <div class="box-content-title">
        <div class="title-font-style">
          <span>团队询价记录</span>
        </div>
      </div>

      <el-form class="search-style">
        <el-row :gutter="20">
          <el-col :span="4">
            <el-form-item>
              <el-select v-model="params.column">
                <el-option
                  v-for="(item,index) in contractScreenCondition"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item>
              <el-input v-model="params.value" placeholder="请输入关键词"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item>
              <el-button @click="searchFor" type="primary">搜索</el-button>
              <el-button @click="resetFor" type>重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="box-table" :style="{height: tableHeight+'px'}">
        <el-table
          border
          ref="tableRef"
          :data="list"
          :max-height="tableHeight"
          tooltip-effect="dark"
          :header-cell-style="tableHeader"
          v-loading="loadingTable"
          element-loading-text="拼命加载中请稍后..."
          element-loading-spinner="el-icon-loading"
        >
          <el-table-column width="120px" show-overflow-tooltip prop="inquiryNumber" label="询价单编号"></el-table-column>
          <el-table-column width="120px" show-overflow-tooltip prop="proType" label="型号"></el-table-column>
          <el-table-column width="120px" show-overflow-tooltip prop="pcName" label="品类"></el-table-column>
          <el-table-column width="120px" show-overflow-tooltip prop="brandName" label="品牌"></el-table-column>
          <el-table-column width="120px" show-overflow-tooltip prop="seriesName" label="系列"></el-table-column>
          <el-table-column width="180px" show-overflow-tooltip prop="proName" label="产品名称"></el-table-column>
          <!-- <el-table-column width="120px"  prop="proType" label="型号"></el-table-column> -->
          <el-table-column width="120px" prop="proType" show-overflow-tooltip label="型号"></el-table-column>
          <el-table-column width="120px" prop="orderNumber" show-overflow-tooltip label="订货号"></el-table-column>
          <!-- <el-table-column width="80px" prop="ocExtype" show-overflow-tooltip label="类型"></el-table-column> -->
          <el-table-column width="100px" prop="ocExtime" show-overflow-tooltip label="货期">
            <template slot-scope="scope">
              <span>{{scope.row.ocExtime+'天'}}</span>
            </template>
          </el-table-column>
          <el-table-column width="50px" prop="ocNeednumber" show-overflow-tooltip label="数量"></el-table-column>
          <el-table-column prop="createUser" label="询价人"></el-table-column>
          <el-table-column width="150px" show-overflow-tooltip prop="orgName" label="所属部门"></el-table-column>
          <el-table-column prop="isManualInquiry" label="询价结果">
            <template slot-scope="scope">
              <span>{{scope.row.isManualInquiry===0?'未询':'已询'}}</span>
            </template>
          </el-table-column>
          <el-table-column width="150px" prop="createDate" label="提交时间">
            <template slot-scope="scope">
              <span>{{scope.row.createDate|dateFilter}}</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作">
            <template slot-scope="scope">
              <el-button @click="onSee(scope.row)" type="text">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <pagination
          :currentPage="currentPage"
          :pageSize="pageSize"
          :total="total"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
        ></pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { expressionList } from '@/components/utils/data'
import { queryPageTeam } from '@/api/purchase/purchasePlanList'
import { deepClone } from '@/util'
import { formatDate } from '@/util/tool'
import pagination from '@/components/pagination'
export default {
  components: {
    pagination: pagination
  },
  data () {
    return {
      activeName: '团队询价记录',
      expressionList: expressionList,
      queryParams: {}, // 搜索条件
      params: {},
      paramsList: {},
      list: [],
      loadingTable: false,
      contractScreenCondition: [
        { label: '品类', value: 'pcName' },
        { label: '品牌', value: 'brandName' },
        { label: '系列', value: 'seriesName' },
        { label: '产品名称', value: 'proName' },
        { label: '询价人', value: 'createUser' },
        { label: '所属部门', value: 'orgName' }
      ],
      total: 0,
      currentPage: 1,
      pageSize: 30,
      tableHeight: window.innerHeight - 390

    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    resetFor () {
      this.currentPage = 1
      this.pageSize = 30
      this.params = {}
      this.paramsList = {}
      this.getList()
    },
    searchFor () {
      this.paramsList = deepClone(this.params)
      if (this.paramsList.value === undefined || this.paramsList.value === '') {
        this.$message.error('请输入搜索条件')
      } else {
        this.currentPage = 1
        this.pageSize = 30
        this.getList()
      }
    },
    handleClick () { },
    getList () {
      this.loadingTable = true
      const params = {
        criteriaVoList: [this.paramsList],
        queryPageName: ''
      }
      queryPageTeam(this.currentPage, this.pageSize, params)
        .then((res) => {
          if (res.data.code === 200) {
            this.loadingTable = false
            this.list = res.data.obj.records
            this.total = res.data.obj.total
            this.$nextTick(() => {
              this.$refs.tableRef.doLayout()
            })
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 查看
    onSee (val) {
      this.$router.push({
        name: 'inquiryResultDetails',
        query: { omiId: val.omiId }
      })
      // this.$router.push({ name: 'inquiryResultDetails' })
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 页数
    handleSizeChange (val) {
      this.pageSize = val
      this.getList()
    },
    // 页码
    handleCurrentChange (val) {
      this.currentPage = val
      this.getList()
    }
  },
  filters: {
    dateFilter
  }
}
function dateFilter (time) {
  if (time === null) {
    return ''
  } else {
    const date = new Date(time)
    return formatDate(date, 'yyyy-MM-dd hh:mm')
  }
}
</script>
